// Tag Closuure Aadhar Verification Modal
import React, { useState } from "react";
import { View, TouchableOpacity} from "react-native";
import CText from "../../common/CText";
import CView from "../../common/CView";
import CButton from "../../common/CButton";
import CImage from "../../common/CImage";
import RadioButton from "../../common/RadioButton";
import CCheckbox from "../../common/CCheckBox";
import applicationStyles from "../../styles/applicationStyles";
import useStyles from "./TagClosure_Styles";
import { AADHAR_MOBILE_CONFIRMATION } from "../../constant/dataHelper";

export default function AdharModal(props) {
  const styles = useStyles();  
  const [isChecked, setIsChecked] = useState(false);
  const closureTagConfirmationModal = props?.closureTagConfirmationModal || false
  const aadharConfirmationModal = props?.aadharConfirmationModal || false
  const aadharMobileVerificationModal = props?.aadharMobileVerificationModal || false
  const aadharConfrimTag = props?.aadharConfrimTag || "2"
 
  return (
    <>
      {closureTagConfirmationModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={applicationStyles.overlayContainer}>
            <View style={applicationStyles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <CText.enterOtpText>{"Undertaking"}</CText.enterOtpText>
                <CView P30H MT={20}>
                  <CView FR >
                    <CView style={applicationStyles.cir5} />
                    <CText.bulletText>{"I confirm that I have completely removed the existing FASTag affixed on my vehicle windscreen"}</CText.bulletText>
                  </CView>
                  <CView FR MT={10}>
                    <CView style={applicationStyles.cir5} />
                    <CText.bulletText>{"I agree to recovery of any pending transactions or debit adjustments from my wallet balance deposit before refund"}</CText.bulletText>
                  </CView>
                  <CView FR MT={10}>
                    <CView style={applicationStyles.cir5} />
                    <CText.bulletText>{"I confirm that the account details and proofs submitted are correct and agree to credit of net refundable amount within 15 working days"}</CText.bulletText>
                  </CView>
                </CView>
                <CView P20H>
                  <CCheckbox termsText={`Yes, I agree`} setIsTermsChecked={setIsChecked} isTermsChecked={isChecked} />
                </CView>
                <View style={styles.footerUndertaking}>
                  <TouchableOpacity style={styles.backBtn} onPress={() => props?.setClosureTagConfirmationModal(false)} >
                    <CText.kycTypeText>{'Cancel'}</CText.kycTypeText>
                  </TouchableOpacity>
                  <CButton title={'Agree'} isDisabled={isChecked ? false : true} onPress={() => { props?.closureTagApi()}} style={styles.closeTagBtn} />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {aadharConfirmationModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={applicationStyles.overlayContainer}>
            <View style={applicationStyles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <CView AC MT={30}>
                  <CImage.IconAadhar></CImage.IconAadhar>
                  <CView MT={20} style={{paddingHorizontal:20}}>
                    <CText.modalTitle>{'Do you have access to you Aadhaar linked mobile number?'}</CText.modalTitle>
                  </CView>
                  <CView P30H MT={20}>
                    <RadioButton
                      PROP={AADHAR_MOBILE_CONFIRMATION}
                      orientation={"row"}
                      dir={"row"}
                      onSelect={(value) => props?.setAadharConfrimTag(value.key) }
                      selectedValue={aadharConfrimTag}
                      redBg={true}
                    />
                  </CView>
                  <CView FR JC W100 MT={20} ML={40}>
                    <CButton 
                      isDisabled = {aadharConfrimTag == ""}
                      title={'Next'}
                      onPress={()=>{
                        if(aadharConfrimTag != ""){
                          aadharConfrimTag == "No" ?  props?.setAadharConfirmationModal(false) : props?.initiate_verification()
                        }
                      }}
                      style={styles.closeTagBtn} />
                  </CView>
                </CView>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {aadharMobileVerificationModal ? (
        <View style={styles.overlayViewStyle}>
          <View style={applicationStyles.overlayContainer}>
            <View style={applicationStyles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <CView AC MT={10}>
                  <CImage.IconError></CImage.IconError>
                  <CView MT={10} P60H>
                    <CText.modalTitle style={{ textAlign: 'center', width: '100%', marginBottom: 20 }}>{'Verification Failed'}</CText.modalTitle>
                    <CText.bulletText>{"Please write an email to etollservices@idfcfirstbank.com regarding the closure of the FASTag account by providing all the necessary details. Please include the following documents "}</CText.bulletText>
                    <CView FR MT={10}>
                      <CView style={applicationStyles.cir5} />
                      <CText.bulletText>{" A cancelled cheque "}</CText.bulletText>
                    </CView>
                    <CView FR MT={10}>
                      <CView style={applicationStyles.cir5} />
                      <CText.bulletText>{"Account number, IFSC code, type of account and the reason behind the closure of the account"}</CText.bulletText>
                    </CView>
                  </CView>
                  <CView FR JC W100 MT={10} ML={40} >
                    <TouchableOpacity style={styles.backBtn} onPress={() => props?.setAadharMobileVerificationModal(false)} >
                      <CText.kycTypeText>{'Cancel'}</CText.kycTypeText>
                    </TouchableOpacity>
                    <CButton title={'OK'} onPress={() => {  props?.setAadharMobileVerificationModal(false) }} style={styles.closeTagBtn} />
                  </CView>
                </CView>
                <CView MT={30} />
              </View>
            </View>
          </View>
        </View>
      ) : null}
    </>
  );
}

